var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("yy-icon-153-" + _vm.type),style:({'font-size': _vm.size})})}
var staticRenderFns = []

export { render, staticRenderFns }